module.exports = __webpack_public_path__ + "ccc81b92e6badab88787ce5b59a787ad.svg";